import { useContext, useEffect, useState } from "react"

// Context
import { UserActivityContext } from "../context/userActivityContext"

// activity tracker
import { ACTIVITY_STATES } from "../hooks/activityTracker/useActivityTracker"

// PrimeReact
import { ConfirmDialog } from "primereact/confirmdialog"

export default function UserActivityWarning() {
  const { state, countdown, resetTimer, logout } =
    useContext(UserActivityContext)

  if (state !== ACTIVITY_STATES.OFFLINE) {
    return null
  }

  return (
    <ConfirmDialog
      visible={true}
      onHide={resetTimer}
      message={
        <div>
          You have been inactive for a while. Do you want to stay logged in?
          <br />
          Automatic logout will occur in {countdown} seconds if no action is
          taken.
        </div>
      }
      header="Inactivity Warning"
      icon="pi pi-exclamation-triangle"
      accept={() => {
        resetTimer()
      }}
      reject={logout}
      defaultFocus="accept"
    />
  )
}
